import React from 'react';

interface RecruiterLensIconProps {
  className?: string;
  size?: number;
}

const RecruiterLensIcon: React.FC<RecruiterLensIconProps> = ({ className = "", size = 24 }) => {
  return (
    <img
      src="/images/icons8-job-seeker-64.png"
      alt="Recruiter Lens Icon"
      width={48}
      height={48}
      className={`${className} w-12 h-12`}
    />
  );
};

export default RecruiterLensIcon;
